var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.496 18.9688L13.7294 2.05225C13.372 1.43339 12.7117 1.05225 11.9972 1.05225C11.2826 1.05225 10.6223 1.43339 10.2649 2.05225L0.428013 19.0905C0.0708705 19.7094 0.0708705 20.4717 0.428013 21.0905C0.785442 21.7094 1.44573 22.0905 2.1603 22.0905H21.8343C21.8363 22.0905 21.8386 22.0905 21.84 22.0905C22.9446 22.0905 23.84 21.1951 23.84 20.0905C23.8397 19.6748 23.7132 19.2885 23.496 18.9688Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.93604C12.6172 6.93604 13.1178 7.43632 13.1178 8.05375L12.832 14.7197C12.8035 15.3226 12.3349 15.5518 12 15.5518C11.6249 15.5518 11.2009 15.354 11.168 14.7197L10.8823 8.05375C10.8823 7.43632 11.3829 6.93604 12 6.93604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0086 18.9312C12.7454 19.1969 12.3768 19.3484 12 19.3484C11.6228 19.3484 11.2543 19.1969 10.9886 18.9312C10.7228 18.6655 10.5714 18.2969 10.5714 17.9198C10.5714 17.5426 10.7228 17.1769 10.9886 16.9112C11.2543 16.6455 11.6228 16.4912 12 16.4912C12.3768 16.4912 12.7454 16.6455 13.0086 16.9112C13.2771 17.1769 13.4286 17.5455 13.4286 17.9198C13.4286 18.2969 13.2771 18.6655 13.0086 18.9312Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("title", null, "warning icon")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.ff9f51c002cf9fafeff58dd4121e38ee.svg";
export { ForwardRef as ReactComponent };